<template>
  <div class="navbar">
    <hamburger id="hamburger-container" :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />
    <el-tooltip content="点击切换左侧菜单显示" effect="dark" placement="bottom">
      <div class="menu-discovery-entry" @click="toggleMenuVisible">
        <i :class="menuVisible ? 'el-icon-s-fold' : 'el-icon-s-unfold'" />
        <span>{{ menuVisible ? '隐藏菜单' : '显示菜单' }}</span>
      </div>
    </el-tooltip>

    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />

    <div class="right-menu">
      <template v-if="device!=='mobile'">
        <search id="header-search" class="right-menu-item" />

<!--        <el-tooltip content="源码地址" effect="dark" placement="bottom">-->
<!--          <git id="magic-git" class="right-menu-item hover-effect" />-->
<!--        </el-tooltip>-->

<!--        <el-tooltip content="文档地址" effect="dark" placement="bottom">-->
<!--          <doc id="magic-doc" class="right-menu-item hover-effect" />-->
<!--        </el-tooltip>-->
        <el-tooltip content="切换语言" effect="dark" placement="bottom">
          <div :class="['lang ',{'blue':$i18n.locale == 'en_US'}]" @click="changeLang">En</div>
        </el-tooltip>
        <el-tooltip content="全屏显示" effect="dark" placement="bottom">
          <screenfull id="screenfull" class="right-menu-item hover-effect" />
        </el-tooltip>
       <!-- <el-tooltip content="布局大小" effect="dark" placement="bottom">
          <size-select id="size-select" class="right-menu-item hover-effect" />
        </el-tooltip>-->

      </template>

      <share-notice />

      <!-- <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
        <span>退出登录</span>
        <el-dropdown-menu slot="dropdown"> -->
          <!-- <div class="avatar-wrapper"> -->
          <!--<img :src="avatar" class="user-avatar">-->
        <router-link to="/user/profile">
          <el-dropdown-item>个人中心</el-dropdown-item>
        </router-link>
          <el-button @click.native="logout" type="text">退出登录</el-button>
          <!-- <i class="el-icon-caret-bottom" /> -->
        </div>

          <!--<el-dropdown-item>-->
            <!--<span @click="setting = true">布局设置</span>-->
          <!--</el-dropdown-item>-->
          <!--<el-dropdown-item divided @click.native="logout">-->
            <!--<span>退出登录</span>-->
          <!--</el-dropdown-item>-->
        <!-- </el-dropdown-menu>
      </el-dropdown> -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import Screenfull from '@/components/Screenfull'
import SizeSelect from '@/components/SizeSelect'
import Search from '@/components/HeaderSearch'
import Git from '@/components/magic4j/Git'
import Doc from '@/components/magic4j/Doc'
import ShareNotice from '@/components/ShareNotice'

export default {
  components: {
    Breadcrumb,
    Hamburger,
    Screenfull,
    SizeSelect,
    Search,
    Git,
    Doc,
    ShareNotice
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'device'
    ]),
    setting: {
      get() {
        return this.$store.state.settings.showSettings
      },
      set(val) {
        this.$store.dispatch('settings/changeSetting', {
          key: 'showSettings',
          value: val
        })
      }
    },
    menuVisible: {
      get() {
        return !this.$store.state.app.menuHidden
      },
      set(value) {
        const menuHidden = !value
        this.$store.dispatch('app/setMenuHidden', menuHidden)
        if (menuHidden) {
          this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
          return
        }
        this.$store.dispatch('app/openSideBar')
      }
    }
  },
  methods: {
    changeLang(){
      this.$i18n.locale = this.$i18n.locale=='zh_CN'?'en_US':'zh_CN'
    },
    toggleSideBar() {
      if (this.$store.state.app.menuHidden) {
        this.$store.dispatch('app/setMenuHidden', false)
        this.$store.dispatch('app/openSideBar')
        return
      }
      this.$store.dispatch('app/toggleSideBar')
    },
    toggleMenuVisible() {
      this.menuVisible = !this.menuVisible
    },
    async logout() {
      this.$confirm('确定要退出系统吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('LogOut').then(() => {
          if(process.env.NODE_ENV === 'development'){
            console.log("------tuichu-----"+  process.env.VUE_APP_LOGOUT_URL)
            location.reload()
            // location.href = 'http://192.168.91.23:8080/logout?service=http://127.0.0.1';
            // this.$router.push({ path: "/" });
          }else{
            location.href = process.env.VUE_APP_LOGOUT_URL;
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.lang{
  width:25px ;
  height: 25px;
  line-height: 25px;
  border-radius: 50%;
  border: 1px solid #ccc;
  text-align: center;
  font-size: 12px;
  cursor: pointer;
}

.blue{
  background: #46a6ff;
  color: #fff;
}

.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background .3s;
    -webkit-tap-highlight-color:transparent;

    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .menu-discovery-entry {
    float: left;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 30px;
    margin-top: 10px;
    margin-left: 4px;
    margin-right: 10px;
    padding: 0 12px;
    border-radius: 15px;
    border: 1px solid #b9ccff;
    background: linear-gradient(90deg, #5b8dff 0%, #7b61ff 52%, #e766b5 100%);
    color: #ffffff;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    box-shadow: 0 4px 10px rgba(99, 117, 230, 0.24);
    transition: all .2s ease;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 6px 14px rgba(99, 117, 230, 0.3);
      opacity: .95;
    }
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    display: flex;
    align-items: center;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background .3s;

        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
